import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Yatay kilidi DENE — garanti değil.
 *
 * Yalnızca tam ekran/kurulu bağlamda ve bazı tarayıcılarda çalışıyor; iOS
 * desteklemiyor. Bu yüzden tek dayanak değil: dikey uyarısı (`RotateHint`)
 * her platformda devrede. Başarısızlığı yutuyoruz, kullanıcıya yansımıyor.
 */
void (async () => {
  try {
    await (screen.orientation as { lock?: (o: string) => Promise<void> })?.lock?.('landscape');
  } catch {
    /* desteklenmiyor ya da tam ekran değil — uyarı katmanı devrede */
  }
})();
